export default __webpack_public_path__ + "static/simply-velvet-9561e3c2a1d9f6a09eac90b4a9bd982c.png";